import { MenteeLookingForOption } from './MenteePortalService';

const MAX = 3;

type Props = {
    options: MenteeLookingForOption[];
    selected: string[];
    readOnly: boolean;
    onChange: (next: string[]) => void;
};

const MenteeRegistrationLookingFor = ({ options, selected, readOnly, onChange }: Props) => {
    const toggle = (slug: string) => {
        if (readOnly) return;
        if (selected.includes(slug)) {
            onChange(selected.filter((s) => s !== slug));
            return;
        }
        if (selected.length >= MAX) return;
        onChange([...selected, slug]);
    };

    return (
        <section className="mreg-card" aria-labelledby="mreg-looking-title">
            <h2 id="mreg-looking-title" className="mreg-card-title">
                What Are You Looking For?
            </h2>
            <p className="mreg-card-sub">
                Select all that apply — this helps us match you with the right mentor.
            </p>
            <ul className="mreg-choice-list">
                {options.map((option) => {
                    const checked = selected.includes(option.slug);
                    const blocked = !checked && selected.length >= MAX;
                    return (
                        <li key={option.slug}>
                            <label
                                className={`mreg-choice${checked ? ' is-selected' : ''}${
                                    blocked || readOnly ? ' is-disabled' : ''
                                }`}
                            >
                                <input
                                    type="checkbox"
                                    className="mreg-choice-input"
                                    checked={checked}
                                    disabled={readOnly || blocked}
                                    onChange={() => toggle(option.slug)}
                                />
                                <span className="mreg-choice-body">
                                    <span className="mreg-choice-label">{option.label}</span>
                                    {option.description ? (
                                        <span className="mreg-choice-desc">— {option.description}</span>
                                    ) : null}
                                </span>
                            </label>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

export default MenteeRegistrationLookingFor;
